import {
  getConventionRegisterPath,
  getConventionSignupStub,
} from '../registerConfig'

export const EVENT_NAME = 'Magifest 2027'
export const EVENT_DATES = '21 - 23 January 2027'
export const STANDARD_TICKET_PRICE = '$400'
export const VIP_TICKET_PRICE = '$600'
export const VIP_UPGRADE_PRICE = '$200'
export const VIP_WORKSHOP_VALUE = '$200'
export const SIGNUP_PRODUCT = getConventionSignupStub('magifest')
export const REGISTRATION_PATH = getConventionRegisterPath('magifest')
